import script from "./RFPsResponses.vue?vue&type=script&setup=true&lang=js"
export * from "./RFPsResponses.vue?vue&type=script&setup=true&lang=js"

import "./RFPsResponses.vue?vue&type=style&index=0&id=180a9492&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-180a9492"]])

export default __exports__